var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { toChildrenArray } from '../_private/utils';
/**
 * Gets all children by specified predicate
 *
 * @since v1.0.0
 * @template T
 * @template TC - Type of child
 * @param {T} children - JSX children
 * @param {(child: TC) => boolean} predicate - The predicate to determine if the given child is a match
 * @returns {TC[]} - All matching children
 * @example
 * // Finds all children that have an 'active' prop set to true
 * getChildren(children, child => child.props.active);
 */
export var getChildren = function (children, predicate) {
    return toChildrenArray(children).filter(predicate);
};
/**
 * Gets all children by specified predicate (deep search)
 *
 * @since v1.0.0
 * @template T
 * @template TC - Type of child
 * @param {T} children - JSX children
 * @param {(child: TC) => boolean} predicate - The predicate to determine if the given child is a match
 * @returns {TC[]} - All matching children
 * @example
 * // Finds the first occurrence of a child that has a prop of 'active' set to true
 * getChildrenDeep(children, child => child.props.active);
 */
export var getChildrenDeep = function (children, predicate) {
    var _a;
    var _children = toChildrenArray(children);
    var output = [];
    for (var _i = 0, _children_1 = _children; _i < _children_1.length; _i++) {
        var child = _children_1[_i];
        if (predicate(child)) {
            output = __spreadArray(__spreadArray([], output), [child]);
        }
        if ((_a = child.props) === null || _a === void 0 ? void 0 : _a.children) {
            output = __spreadArray(__spreadArray([], output), getChildrenDeep(child.props.children, predicate));
        }
    }
    return output;
};
